const shadows = {
    outlinePrimary400: 'inset 0px 0px 0px 4px rgba(80, 178, 194, 0.25)',
    outlineWhite: 'inset 0px 0px 0px 4px rgba(255, 255, 255, 0.25)',
    card: '0px 4px 8px rgba(61, 56, 54, 0.04), 0px 8px 16px rgba(61, 56, 54, 0.04), 0px 12px 32px rgba(61, 56, 54, 0.12)',
    dotPrimary400: '0px 0px 10px rgba(130, 197, 203, 1)',
    dotSecondary400: '0px 0px 10px 0px rgba(237, 121, 57, 1)',
};
export default shadows;
